import React from 'react';

import style from './PublicLayoutHeader.module.scss';

export const PublicLayoutHeader: React.FC = ({ children }) => {
	return <div className={style.content}>{children}</div>;
};
